export class RoiReport {
  kpis: RoiReportKpi[];
  datas: RoiReportData[];
  totalRow: number;
}

export class RoiReportKpi {
  name: string;
  value: number;

}

export class RoiReportData {
  ROI_value: number;
  id: number;
  impression: number;
  influencerId: number;
  influencerName: string;
  influencerImage: string;
  country: any;
  platformBlogs: boolean;
  platformFacebook: boolean;
  platformInstagram: boolean;
  platformYoutube: boolean;
  platformTiktok: boolean;
  post_num: number;
  reach: number;
}

export class RoiSetting {
  companyId: number;
  calculationMethod: number;
  currency: number;
  blog: number;
  instagram: number;
  youtube: number;
  tiktok: number;
  instagramStory: number;
  instagramReel: number;
}



// WEBPACK FOOTER //
// ./src/models/measure/roi-report.ts